import React from 'react';
import './App.css';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import {history} from "./Helpers/history";
import {Provider} from "react-redux";
import store from "./Redux/redux-store";
import {NotFoundPage} from "./Components/NotFoundPage/NotFoundPage";
import {AppScreen} from "./MainScreen/AppScreen";
import {EmptyScreen} from "./MainScreen/EmptyScreen";

function App() {
    return (
        <BrowserRouter history={history}>
            <Provider store={store}>
                <Switch>
                    <Redirect from="/Report" to="/xCircular/XCircularKeshetTeamimSignage/XCircularKeshetTeamimSignageWcfService/GetAnalyticsExcel"/>
                    <Route exact path="/" component={AppScreen} />
                    <Route exact path="/xCircular/XCircularKeshetTeamimSignage/XCircularKeshetTeamimSignageWcfService/GetAnalyticsExcel" component={EmptyScreen} />
                    <Route path={`/404`} component={NotFoundPage} />
                    <Redirect from="*" to="/404"/>
                </Switch>
            </Provider>
        </BrowserRouter>
    );
}

export default App;
